module.exports = __webpack_public_path__ + "img/t2.070bcc55.png";